// This file is generated at build time
export const BUILD_VERSION = '2025-09-22 23:56:48';
export const BUILD_TIMESTAMP = '2025-09-22T23:56:48.426Z';
